import { BarChart2, ChevronDown } from 'lucide-react';

export default function SpotPriceTrigger({ en, displayPrice, open, onClick, className = '' }) {
  return <button type="button" onClick={onClick} aria-expanded={open} aria-haspopup="dialog"
    aria-label={en ? 'Open live electricity prices' : 'Åbn aktuelle elpriser'}
    className={`spot-price-trigger ${className}`}>
    <BarChart2 className="spot-price-icon" size={18} aria-hidden="true" />
    <span className="spot-price-label">{en ? 'Price now' : 'Elpris nu'}</span>
    <span className="spot-price-value"><strong>{displayPrice}</strong><span className="spot-price-unit">{en ? 'DKK/kWh' : 'kr./kWh'}</span></span>
    <ChevronDown className="spot-price-chevron" size={14} aria-hidden="true" />
  </button>;
}